import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { POLICYRISK_INIT_LOADING, POLICYRISK_INIT_SUCCESS, POLICYRISK_INIT_FAIL, POLICYRISK_SAVE_LOADING, POLICYRISK_SAVE_SUCCESS, POLICYRISK_SAVE_FAIL,
  POLICYRISK_LIST, RISKCLSE_SAVE_LOADING, RISKCLSE_SAVE_SUCCESS, RISKCLSE_SAVE_FAIL, POLRISKSTATS_SAVE_LOADING, POLRISKSTATS_SAVE_SUCCESS, POLRISKSTATS_SAVE_FAIL,
  POLICYFIRERISK_INIT_LOADING, POLICYFIRERISK_INIT_SUCCESS, POLICYFIRERISK_INIT_FAIL, POLICYFIRERISK_SAVE_LOADING, POLICYFIRERISK_SAVE_SUCCESS,
  POLICYFIRERISK_SAVE_FAIL, POLICYBONDRISK_INIT_LOADING, POLICYBONDRISK_INIT_SUCCESS, POLICYBONDRISK_INIT_FAIL, POLICYMISCWRKMAN_SAVE_LOADING,
  POLICYMISCWRKMAN_SAVE_SUCCESS, POLICYMISCWRKMAN_SAVE_FAIL, POLICYMISCWRKMAN_LIST, POLICYMISCEMPYT_SAVE_LOADING, POLICYMISCEMPYT_SAVE_SUCCESS,
  POLICYMISCEMPYT_SAVE_FAIL, POLICYMOTORRISK_INIT_LOADING, POLICYMOTORRISK_INIT_SUCCESS, POLICYMOTORRISK_INIT_FAIL, POLICYMOTORRISK_SAVE_LOADING,
  POLICYMOTORRISK_SAVE_SUCCESS, POLICYMOTORRISK_SAVE_FAIL, POLICYMOTORDRIVER_SAVE_LOADING, POLICYMOTORDRIVER_SAVE_SUCCESS, POLICYMOTORDRIVER_SAVE_FAIL,
  POLICYMOTORDRIVER_LIST, POLICYHULLRISK_INIT_LOADING, POLICYHULLRISK_INIT_SUCCESS, POLICYHULLRISK_INIT_FAIL, POLICYHULLRISK_SAVE_LOADING,
  POLICYHULLRISK_SAVE_SUCCESS, POLICYHULLRISK_SAVE_FAIL, POLICYCARGORISK_INIT_LOADING, POLICYCARGORISK_INIT_SUCCESS, POLICYCARGORISK_INIT_FAIL,
  POLICYCARGORISK_SAVE_LOADING, POLICYCARGORISK_SAVE_SUCCESS, POLICYCARGORISK_SAVE_FAIL, POLRISKBLK_SAVE_LOADING, POLRISKBLK_SAVE_SUCCESS,
  POLRISKBLK_SAVE_FAIL, RISKTRAILER_SAVE_LOADING, RISKTRAILER_SAVE_SUCCESS, RISKTRAILER_SAVE_FAIL, POLICYGENERAL_LOAD_DATA, POLBORDITEM_SAVE_LOADING,
  POLBORDITEM_SAVE_SUCCESS, POLBORDITEM_SAVE_FAIL, POLEMPYEEDET_SAVE_LOADING, POLEMPYEEDET_SAVE_SUCCESS, POLEMPYEEDET_SAVE_FAIL } from '@/store/types'

export const risk = {
  async policyRiskInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policyRisk
    commit(POLICYRISK_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLICYRISK_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(POLICYRISK_INIT_FAIL, extractMessages(error))
    }
  },
  async savePolRisk({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskSettings.menu.saveMiscRisk
    if (apiUrl) {
      commit(POLICYRISK_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYRISK_SAVE_SUCCESS)
          commit(POLICYRISK_LIST, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYRISK_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYRISK_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Risk']))
        }
        return false
      }
    } else {
      commit(POLICYRISK_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async saveRiskClse ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskSettings.menu.saveRiskClause
    if (apiUrl) {
      commit(RISKCLSE_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(RISKCLSE_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(RISKCLSE_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(RISKCLSE_SAVE_FAIL, generateManualSaveError(['Fail to create Risk Clause']))
        }
        return false
      }
    } else {
      commit(RISKCLSE_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolRiskStats ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskSettings.menu.savePolRiskStats
    if (apiUrl) {
      commit(POLRISKSTATS_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLRISKSTATS_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLRISKSTATS_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLRISKSTATS_SAVE_FAIL, generateManualSaveError(['Fail to create Policy Risk Statistics']))
        }
        return false
      }
    } else {
      commit(POLRISKSTATS_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async policyFireRiskInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policyFireRisk
    commit(POLICYFIRERISK_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLICYFIRERISK_INIT_SUCCESS, commitResult)
      return true
    } catch (error) {
      commit(POLICYFIRERISK_INIT_FAIL, extractMessages(error))
      return false
    }
  },
  async savePolFireRisk({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyFireRiskSettings.menu.savePolFireRisk
    if (apiUrl) {
      commit(POLICYFIRERISK_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          commit(POLICYFIRERISK_SAVE_SUCCESS)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYFIRERISK_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYFIRERISK_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Risk']))
        }
        return false
      }
    } else {
      commit(POLICYFIRERISK_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async policyBondRiskInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policyBondRisk
    commit(POLICYBONDRISK_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLICYBONDRISK_INIT_SUCCESS, commitResult)
      return true
    } catch (error) {
      commit(POLICYBONDRISK_INIT_FAIL, extractMessages(error))
      return false
    }
  },
  async savePolMiscWrkman({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyBondRiskSettings.menu.saveWorker
    if (apiUrl) {
      commit(POLICYMISCWRKMAN_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYMISCWRKMAN_SAVE_SUCCESS)
          commit(POLICYMISCWRKMAN_LIST, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYMISCWRKMAN_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYMISCWRKMAN_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Worker Details']))
        }
        return false
      }
    } else {
      commit(POLICYMISCWRKMAN_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolMiscEmpyt({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyBondRiskSettings.menu.saveBond
    if (apiUrl) {
      commit(POLICYMISCEMPYT_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          commit(POLICYMISCEMPYT_SAVE_SUCCESS)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYMISCEMPYT_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYMISCEMPYT_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Bond Risk']))
        }
        return false
      }
    } else {
      commit(POLICYMISCEMPYT_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async policyMotorRiskInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policyMotorRisk
    commit(POLICYMOTORRISK_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLICYMOTORRISK_INIT_SUCCESS, commitResult)
      return true
    } catch (error) {
      commit(POLICYMOTORRISK_INIT_FAIL, extractMessages(error))
      return false
    }
  },
  async savePolMtrRisk({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyMotorRiskSettings.menu.saveMotor
    if (apiUrl) {
      commit(POLICYMOTORRISK_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          commit(POLICYMOTORRISK_SAVE_SUCCESS)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYMOTORRISK_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYMOTORRISK_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Motor Risk']))
        }
        return false
      }
    } else {
      commit(POLICYMOTORRISK_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolMtrDrv({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyMotorRiskSettings.menu.saveDriver
    if (apiUrl) {
      commit(POLICYMOTORDRIVER_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYMOTORDRIVER_SAVE_SUCCESS)
          commit(POLICYMOTORDRIVER_LIST, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYMOTORDRIVER_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYMOTORDRIVER_SAVE_FAIL, generateManualSaveError(['Fail to save Named Driver']))
        }
        return false
      }
    } else {
      commit(POLICYMOTORDRIVER_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async policyHullRiskInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policyHullRisk
    commit(POLICYHULLRISK_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLICYHULLRISK_INIT_SUCCESS, commitResult)
      return true
    } catch (error) {
      commit(POLICYHULLRISK_INIT_FAIL, extractMessages(error))
      return false
    }
  },
  async savePolHullRisk({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyHullRiskSettings.menu.saveHull
    if (apiUrl) {
      commit(POLICYHULLRISK_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          commit(POLICYHULLRISK_SAVE_SUCCESS)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYHULLRISK_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYHULLRISK_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Hull Risk']))
        }
        return false
      }
    } else {
      commit(POLICYHULLRISK_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async policyCargoRiskInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policyCargoRisk
    commit(POLICYCARGORISK_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLICYCARGORISK_INIT_SUCCESS, commitResult)
      return true
    } catch (error) {
      commit(POLICYCARGORISK_INIT_FAIL, extractMessages(error))
      return false
    }
  },
  async savePolCargoRisk({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyCargoRiskSettings.menu.saveCargo
    if (apiUrl) {
      commit(POLICYCARGORISK_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          commit(POLICYCARGORISK_SAVE_SUCCESS)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYCARGORISK_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYCARGORISK_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Cargo Risk']))
        }
        return false
      }
    } else {
      commit(POLICYCARGORISK_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolRiskBlock ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskSettings.menu.saveRiskBlock
    if (apiUrl) {
      commit(POLRISKBLK_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLRISKBLK_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLRISKBLK_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLRISKBLK_SAVE_FAIL, generateManualSaveError(['Fail to create Policy Risk Block']))
        }
        return false
      }
    } else {
      commit(POLRISKBLK_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async saveRiskTrailer ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskItemSettings.menu.saveRiskTrailer
    if (apiUrl) {
      commit(RISKTRAILER_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(RISKTRAILER_SAVE_SUCCESS)
          commit(POLICYGENERAL_LOAD_DATA, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(RISKTRAILER_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(RISKTRAILER_SAVE_FAIL, generateManualSaveError(['Fail to save Risk Trailer']))
        }
        return false
      }
    } else {
      commit(RISKTRAILER_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolBordItem ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskItemSettings.menu.savePolBordItem
    if (apiUrl) {
      commit(POLBORDITEM_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLBORDITEM_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLBORDITEM_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLBORDITEM_SAVE_FAIL, generateManualSaveError(['Fail to create Policy Bordereaux Item']))
        }
        return false
      }
    } else {
      commit(POLBORDITEM_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolEmpyeeDet ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskSettings.menu.savePolEmpyeeDet
    if (apiUrl) {
      commit(POLEMPYEEDET_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLEMPYEEDET_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLEMPYEEDET_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLEMPYEEDET_SAVE_FAIL, generateManualSaveError(['Fail to create Policy Employee Details']))
        }
        return false
      }
    } else {
      commit(POLEMPYEEDET_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  }
}

/**
 * To put manual messages into saveError
 * @param {Array of String} msgs
 */
const generateManualSaveError = (msgs) => {
  if (msgs && msgs.length > 0) {
    return {
      fieldMessages: [],
      messages: msgs
    }
  } else {
    return {
      fieldMessages: [],
      messages: []
    }
  }
}

/**
 * Format server return object to dialog readable format
 * @param {Server return object data} data
 */
const formatServerSaveError = (data) => {
  let fieldMessages = []
  let messages = []

  if (data) {
    if (data.messages && data.messages.length > 0) {
      for (const err of data.messages) {
        messages.push(err.message)
      }
    }
    if (data.fieldMessages && data.fieldMessages.length > 0) {
      for (const err of data.fieldMessages) {
        fieldMessages.push(err.field + ': ' + err.message.message)
      }
    }
  }
  return {
    fieldMessages: fieldMessages,
    messages: messages
  }
}
